import BaseStore from 'customer-flows/stores/base-store'
import { trackedAsync, type Awaitable } from 'customer-flows/utils/core'

export default class FlowStoreClass extends BaseStore {
  @trackedAsync() flowConfig: Awaitable<FlowConfig>

  get pages () {
    return this.flowConfig.value?.pages ?? []
  }

  hasStep (stepName: StepType): boolean {
    const step = this.pages
      .flatMap((page) => page.steps ?? [])
      .find((step) => step.__typename === stepName)

    return step?.visible ?? false
  }
}

declare global {
  export type FlowStore = FlowStoreClass
  export interface StoreRegistry {
    flow: FlowStore
  }
}
